<template>
    <div class="hijry">
        <div class="milady-div">
            <h2> التاريخ الهجري </h2>
            <h2 name="hijryDate">2-4-2022</h2>
        </div>

        <div class="events">
            <p>
                <span> بداية السنة الهجرية </span>
                <span>1 محرم 1444</span>
            </p>
            <p>
                <span> عاشوراء </span>
                <span>10 محرم 1444</span>
            </p>
            <p>
                <span> رمضان </span>
                <span>1 رمضان 1445</span>
            </p>
            <p>
                <span> عيد الفطر </span>
                <span>1 شوال 1445</span>
            </p>
            <p>
                <span> أول أيام الحج </span>
                <span>8 ذو الحجة 1445</span>
            </p>
            <p>
                <span> يوم عرفة </span>
                <span>9 ذو الحجة 1445</span>
            </p>
            <p>
                <span> عيد الأضحى </span>
                <span>10 ذو الحجة 1445</span>
            </p>
            <p><span> التوقيت الصحيح يعتمد على الرؤية الشرعية </span></p>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            dateH() {
                var hijryRealTime = new Intl.DateTimeFormat('ar-TN-u-ca-islamic', {day: 'numeric',month: 'long',weekday: 'long',year : 'numeric'}).format(Date.now());
                document.querySelector("[name='hijryDate']").innerText = hijryRealTime;
            }
        },
        mounted() {
            this.dateH();
        }
    }
</script>